<template>
  <div>
    <Breadcrumbs title="Database" main="Research"/>
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-4">

                <div class="col-md-6">
                  <router-link
                        to="/research/database/add"
                      custom
                      v-slot="{ href, route, navigate, isActive, isExactActive }"
                  >
                    <a :href="href" @click="navigate" class="btn btn-outline-info mr-2">Add Record</a>
                  </router-link>
                  <router-link
                        to="/research/database/add-combo"
                      custom
                      v-slot="{ href, route, navigate, isActive, isExactActive }"
                  >
                    <a :href="href" @click="navigate" class="btn btn-outline-info mr-2">Add Combo</a>
                  </router-link>
                  <router-link
                        to="/research/database/add-batch"
                      custom
                      v-slot="{ href, route, navigate, isActive, isExactActive }"
                  >
                    <a :href="href" @click="navigate" class="btn btn-outline-info mr-2">Add Batch</a>
                  </router-link>
                </div>
                <div class="col-md-4 offset-md-2">
                  <div class="pull-right">
                    <form @submit.prevent="getList">
                      <div class="input-group">

                        <input class="form-control" placeholder="Filter" v-model="query">
                        <div class="input-group-append">
                          <button class="btn btn-primary" type="submit">Search</button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>

              <div class="col-md-2 offset-md-10">
                <div class="pull-right mb-2">
                  <b>ENTRY'S:</b> {{ totalRows || 0 }}
                </div>
              </div>

              <div class="table-responsive mb-4">
                <table role="table" aria-busy="false" aria-colcount="4"
                       class="table b-table table-striped table-hover">
                  <thead role="rowgroup" class="">
                  <tr role="row" class="">
                    <th>Date</th>
                    <th>Part Number</th>
                    <th>Brand</th>
                    <th>Name</th>
                    <th>Price</th>
                    <th>Competitor</th>
                    <th>Actions</th>
                  </tr>
                  </thead>
                  <tbody role="rowgroup">
                  <tr role="row" v-for="(product, index) in products" :key="index" :class="{ 'bg-light': product.combo_id }">
                    <td v-if="product.combo_id">
                      {{ product.date }}
                      <span v-for="(productCombo, key) in product.combo_products" :key="key"><br>{{ productCombo.date }}</span>
                    </td>
                    <td v-else>{{ product.date }}</td>

                    <td v-if="product.combo_id">
                      {{ product.part_number }}
                      <span v-for="(productCombo, key) in product.combo_products" :key="key"><br>{{ productCombo.part_number }}</span>
                    </td>
                    <td v-else>{{ product.part_number }}</td>

                    <td v-if="product.combo_id">
                      {{ product.brand }}
                      <span v-for="(productCombo, key) in product.combo_products" :key="key"><br>{{ productCombo.brand }}</span>
                    </td>
                    <td v-else>{{ product.brand }}</td>

                    <td v-if="product.combo_id">
                      {{ product.name }}
                      <span v-for="(productCombo, key) in product.combo_products" :key="key"><br>{{ productCombo.name }}</span>
                    </td>
                    <td v-else>{{ product.name }}</td>

                    <td>${{ product.price }}</td>

                    <td v-if="product.combo_id">
                      {{ product.competitor }}
                      <span v-for="(productCombo, key) in product.combo_products" :key="key"><br>{{ productCombo.competitor }}</span>
                    </td>
                    <td v-else>{{ product.competitor }}</td>

                    <td>View</td>
                  </tr>
                  </tbody>
                </table>
              </div>

              <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  class="my-0"
              ></b-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {competitorProduct} from "../../../_services";

export default {
  data: function () {
    return {
      currentPage: 1,
      perPage: 10,
      query: null,
      totalRows: null,
      products: null
    }
  },
  watch: {
    currentPage: function () {
      this.getList();
    }
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      competitorProduct.getList(
          this.query,
          this.perPage,
          this.currentPage
      )
          .then(
              async response => {
                this.products = response.data.list;
                this.totalRows = response.data.count;
              },
              error => {
                const {dispatch} = this.$store;
                dispatch('alert/error', error, {root: true});
              }
          );
    },
  }
}
</script>
